import React from "react";
import style from "../../sass/project.module.scss";
import Span from "../../helper/Span";
import ProjectData from "./ProjecData";
import ProjectLayout from "./ProjectLayout";
const Project = () => {
     return (
          <section className={style.project}>
               <div className={style.project_container}>
                    <div className={style.project_heading}>
                         {"Project".split("").map((alphabet) => (
                              <Span alp={alphabet} />
                         ))}
                    </div>
                    <div className={style.project_content}>
                         {ProjectData.map((item, index) => (
                              <ProjectLayout {...item} key={index} />
                         ))}
                    </div>
               </div>
          </section>
     );
};
export default Project;
